// ARKA — espelho em JS dos tokens de tokens.css (FONTE CANÔNICA: design/arka/).
// Serve para libs que precisam de cor em hex (MUI calcula hover/contraste a partir
// do valor; com var(--x) ele quebra). Mudou um hex em tokens.css? Mude aqui também
// e rode design/arka/sync.sh.

export const arkaColors = {
  dark: {
    bg: '#0C0E13', bgDeep: '#090A0E',
    surface: '#13161D', surface2: '#191D26', surface3: '#20252F',
    border: '#242A35', borderStrong: '#333B49',
    text: '#EEF1F6', text2: '#A3ABB9', text3: '#828A9B',
    accent: '#FF6A3D', accentStrong: '#FF5426', onAccent: '#1A0A03',
    accentInk: '#FF6A3D', accentFill: '#FF6A3D',
    success: '#38C58C', danger: '#F0616B', warning: '#E6A91E', info: '#5B9DFF',
  },
  light: {
    bg: '#F5F6F9', bgDeep: '#EDEFF3',
    surface: '#FFFFFF', surface2: '#F4F6F9', surface3: '#ECEFF4',
    border: '#E4E7EC', borderStrong: '#CFD5DE',
    text: '#121622', text2: '#525A68', text3: '#646B79',
    accent: '#F0531C', accentStrong: '#D8410F', onAccent: '#1A0A03',
    accentInk: '#B23709', accentFill: '#F0531C',
    success: '#0E7550', danger: '#B52B34', warning: '#875F10', info: '#2A5FD6',
  },
};

export const arkaFonts = {
  display: '"Bricolage Grotesque", "Hanken Grotesk", system-ui, sans-serif',
  ui: '"Hanken Grotesk", system-ui, -apple-system, "Segoe UI", sans-serif',
  mono: '"JetBrains Mono", ui-monospace, SFMono-Regular, Menlo, monospace',
};

export const arkaRadius = { surface: 12, control: 8, pill: 999 };

export const ARKA_THEME_KEY = 'arka-theme';

export function getArkaMode() {
  if (typeof document === 'undefined') return 'dark';
  return document.documentElement.getAttribute('data-theme') === 'light' ? 'light' : 'dark';
}

export function setArkaMode(mode) {
  const next = mode === 'light' ? 'light' : 'dark';
  document.documentElement.setAttribute('data-theme', next);
  try { window.localStorage.setItem(ARKA_THEME_KEY, next); } catch (e) { /* storage bloqueado: vale só nesta aba */ }
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', arkaColors[next].bg);
  return next;
}
